export default __webpack_public_path__ + "static/media/lbank.217db3f1.svg";